import OSM from "ol/source/OSM";

function osm() {
	return new OSM();
}

export default osm;